import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getEligiblePrograms = (
    encounterId,
    customerId,
    includeIneligible = false,
    shouldReturnLTCProgram = false
) =>
    createAction("GET_ELIGIBLE_PROGRAMS", (dispatch, getState) =>
        Axios.get(
            `/api/eligibility/customer/${customerId}/invoke/${encounterId}/${includeIneligible}/${shouldReturnLTCProgram}`
        ).then(data => {
            const cashDiscounts = data.data.filter(x => x.assistanceCategory === "Cash Discount");
            let cashDiscount = data.data.filter(x => x.assistanceCategory === "Cash Discount")[0];

            // This should never happen, but because of a bug in customer admin, this is happening.
            if (cashDiscounts.length > 1) {
                let approvedCashDiscount = cashDiscounts.filter(
                    x =>
                        x.eligibilityStatus.name === "Approved" &&
                        x.eligibilityDeterminationStatus.name === "Action Complete"
                )[0];
                if (approvedCashDiscount) {
                    cashDiscount = approvedCashDiscount;
                }
            }

            const allProgramsButCash = data.data.filter(x => x.assistanceCategory !== "Cash Discount");
            if (cashDiscount == null) {
                return allProgramsButCash;
            }
            const creditCard = {
                ...cashDiscount,
                isBestFit: false,
                details: [
                    {
                        key: "Dispatch_S1_Line1",
                        value:
                            "Based on the information provided, The patient or other responsible party will pay personally with credit",
                    },
                    {
                        key: "Dispatch_S2_Line1",
                        value: "Payment will be collected through hospital billing department",
                    },
                    {
                        key: "Dispatch_S2_Line2",
                        value:
                            "Patient should notify hospital immediately if they enroll in any type of healthcare coverage or have a change in personal finances that may qualify them for other forms of financial assistance",
                    },
                    {
                        key: "Line1",
                        value: "Personal",
                    },
                    {
                        key: "Line1a",
                        value: "Credit or debit",
                    },
                    {
                        key: "Line2",
                        value: "Payment Preference",
                    },
                    {
                        key: "Line3",
                        value: "Noted for future billing",
                    },
                    {
                        key: "Title",
                        value: "Credit",
                    },
                ],
            };

            const isMarketplaceCreditApproved = getState().interview.isMarketplaceCreditApproved;
            if (cashDiscount.eligibilityStatus.name === "Approved") {
                if (isMarketplaceCreditApproved) {
                    cashDiscount.eligibilityStatus = {
                        name: "Pending",
                    };

                    cashDiscount.eligibilityDeterminationStatus = {
                        name: "Pending Action",
                    };
                } else {
                    creditCard.eligibilityStatus = {
                        name: "Pending",
                    };

                    creditCard.eligibilityDeterminationStatus = {
                        name: "Pending Action",
                    };
                }
            }
            return allProgramsButCash.concat(...[cashDiscount, creditCard]);
        })
    );

export const resetPrograms = () => createAction("RESET_PROGRAMS", {});

export const approveProgram = (selectedProgram, customerId) =>
    createAction("APPROVE_PROGRAM", (dispatch, getState) =>
        Axios.put(
            `/api/eligibility/approve/${selectedProgram.eligibilityDeterminationResultId}?offerId=${
                selectedProgram.offerId
            }`
        ).then(() => {
            var encounterId = getState().interview.encounterId;
            return dispatch(getEligiblePrograms(encounterId, customerId));
        })
    );

export const denyProgram = (selectedProgram, customerId) =>
    createAction("DENY_PROGRAM", (dispatch, getState) =>
        Axios.put(`/api/eligibility/deny/${selectedProgram.eligibilityDeterminationResultId}`).then(() => {
            var encounterId = getState().interview.encounterId;
            if (selectedProgram?.programDetails?.Title == "LTC") {
                return dispatch(getEligiblePrograms((encounterId = encounterId), customerId, false, true));
            }
            return dispatch(getEligiblePrograms(encounterId, customerId));
        })
    );
